var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_206_54",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_206_54",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAAB0klEQVRYhe1Xi22EMAx1u8CxQW+DY4OyQRmBEW4ERmAEukE6QekGjMBtkJvAFZKRHj7n10o9qa0lpJDYLy8fP8MDM9M97fGus/8WAs1PEqiI6ExEExGxPO/QnmT8mI24XsLMp2dmz/k2MHOVws7JgnU1johO0Pcmq52VX0tEL9B3kT70K9qBWq3aMfMxEbOOjxDjBcf0jwGt2zcDUFdwXCT+SMI8jhjA8I3JLRKuhMARAgfV3xcS6gGrySWwrV5v3RgDixzldo/GXAKLEYC7YoJlHKfXY5YQren0JG2n+tGqVP6CjdI8EFGdSsMGVlmprUQLplbgMY8uJcVetV/hvTb8c2wXV1oLeiK6Snv4IomlhICeYA3upH2A4rP5sshup+Lw/vjdSOK8zoHxVkn0YhSqNiBIO0UMEXDiPEcuVa2kWhuK1RTCy5HQNkJi813A36ubjll1o6Ax4AUAk3VddqQxUnfDWSycGOAEgSX5jpPjEZk7GQrGbesBMFd89P0YQr6p1bNo/qzeQ/eiVgWLUzXD+iRr5EMzxz7A51n5X0UPXAzHIjApsIv0TSIoHRQry66iksON6GQQaITxNqHT0ilWiy9WRG98qCbt/9/wjxMgok9b2Vs9YS16qAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.e5f26658817bfafe59582145c04dd7fe.svg";
export { ForwardRef as ReactComponent };